/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingsharedplan3Inputs */

const en_profilebillingsharedplan3 = /** @type {(inputs: Profilebillingsharedplan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization’s plan`)
};

const de_profilebillingsharedplan3 = /** @type {(inputs: Profilebillingsharedplan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan der Organisation`)
};

/**
* | output |
* | --- |
* | "Organization’s plan" |
*
* @param {Profilebillingsharedplan3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingsharedplan3 = /** @type {((inputs?: Profilebillingsharedplan3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingsharedplan3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingsharedplan3(inputs)
	return de_profilebillingsharedplan3(inputs)
});
export { profilebillingsharedplan3 as "profileBillingSharedPlan" }